import React, { useEffect, useState } from "react";
import { IconButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import { connect } from "../../../base/redux";
import { getModeChangeList, setDocumentSharedFile, setFocusShareDocument } from "../../../share-document";
import { layoutType, videoLayoutMode } from "../../../video-layout-mode";
import LayoutIconButton from "./LayoutIconButton";
import SetGridCount from "./SetGridCount";

function SharingButton({ 
    t, dispatch, screenType, list, mode, currentShare 
}) {
    if (!list) return null;
    const [ isMobileDropDown, setIsMobileDropDown ] = useState(false);
    const [ isMobile, setIsMobile ] = useState(false);
    const [ optionDrop, setOptionDrop ] = useState(false);

    useEffect(() => {
        const mobile = screenType === layoutType.desktop ? false : true;

        setIsMobileDropDown(false);
        setIsMobile(mobile);
    }, [screenType]);

    const onFocusDocument = async () => {
        const newList = {
            ...currentShare.list,
            shared: true
        };

        await dispatch(setDocumentSharedFile(newList));
        await dispatch(setFocusShareDocument(currentShare.uuid, currentShare.index, currentShare.list.isWhiteBoard, false));
    }

    const onShowOption = () => {
        setOptionDrop(!optionDrop);
    }

    return (
        <>  
            { optionDrop && <SetGridCount setOptionDrop={setOptionDrop} /> }

            {/* 레이아웃 리스트 버튼 */}
            <LayoutIconButton list={list} mode={mode} isMobile={isMobile} optionDrop={optionDrop} setOptionDrop={setOptionDrop}>
                {/* 현재 문서 공유 버튼 */}
                { currentShare !== false && 
                    <IconButton clsName="option" 
                        mode={"current"} 
                        name={ isMobile ? false : t("layout.shareCurrentDocument")} 
                        onClick={onFocusDocument}
                    />
                }

                {/* 옵션 버튼 */}
                { isMobile && videoLayoutMode.grid === mode && 
                    <IconButton clsName="option" mode={"option"} 
                        onClick={onShowOption}
                    />
                }
            </LayoutIconButton>            
        </>
    )
}

function _mapStateToProps(state) {
    // list 
    const { list, mode, currentShare } = getModeChangeList(state);

    return {
        list, mode, currentShare
    };
}


export default translate(connect(_mapStateToProps)(SharingButton));